import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FetchPermissionsTemplate, FetchUserPermissionsForCurrentStartup } from 'api';
import { SET_IS_SUBSCRIBED, SET_PERMISSION_TEMPLATE, SET_USER_ACCESS } from 'store/actions';
import { adminPermission, hasPermissionForRoute } from 'utilities/index';
import { HandleUser } from 'utilities/mixpanel';
import { GetSubscriptionDetails } from 'api/subscription';

const PermissionsHandler = ({ startup_id }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    const startupDetail = useSelector((state) => state?.startupDetails?.data);

    const {
        data: permissions_template,
        isLoading: isLoadingPermissionsTemplate,
    } = FetchPermissionsTemplate();

    const {
        data: user_access_info,
        isLoading: isLoadingUserAccessInfo,
    } = FetchUserPermissionsForCurrentStartup({ startup_id });

    const {
        data: subscriptionDetails,
        isLoading: isLoadingSubscriptionDetails,
    } = GetSubscriptionDetails({ id: startup_id });

    // Effect to set permissions template and user access info
    useEffect(() => {
        if (!isLoadingPermissionsTemplate && permissions_template &&
            !isLoadingUserAccessInfo && user_access_info) {

            dispatch({ type: SET_PERMISSION_TEMPLATE, data: permissions_template });

            const permissionsData = user_access_info?.is_owner
                ? adminPermission({ permissionsTemplate: permissions_template })
                : { ...user_access_info.permission };

            HandleUser({
                savedData: { ...user_access_info },
                startup_name: startupDetail?.startup_name
            });

            dispatch({
                type: SET_USER_ACCESS,
                permissions: permissionsData,
                isOwner: user_access_info?.is_owner,
                userName: user_access_info?.name,
                otherData: user_access_info
            });
        }
    }, [
        permissions_template,
        user_access_info,
        isLoadingPermissionsTemplate,
        isLoadingUserAccessInfo,
        dispatch,
        startupDetail?.startup_name
    ]);

    // Effect to handle subscription status
    useEffect(() => {
        if (!subscriptionDetails) {
            if (!isLoadingSubscriptionDetails) {
                dispatch({ type: SET_IS_SUBSCRIBED, loading_subscription: false });
            }
            return;
        }

        const now = Date.now();
        const isSubscribed =
            subscriptionDetails?.status === "active" &&
            subscriptionDetails?.current_end &&
            ((now / 1000) < subscriptionDetails.current_end);

        dispatch({
            type: SET_IS_SUBSCRIBED,
            is_subscribed: isSubscribed,
            current_plan: subscriptionDetails?.title,
            subscription_details: subscriptionDetails,
            loading_subscription: isLoadingSubscriptionDetails
        });
    }, [subscriptionDetails, isLoadingSubscriptionDetails, dispatch]);

    // Effect to check and validate route permissions
    useEffect(() => {
        if (startup_id && userPermissions) {
            if (!hasPermissionForRoute(userPermissions, location.pathname)) {
                navigate('/', { replace: true });
            }
        }
    }, [startup_id, userPermissions, location.pathname, navigate]);

    return null;
};

export default PermissionsHandler;
